import { defineMessages } from 'react-intl';

const messages = defineMessages({
  dutiesAndTaxesLabel: {
    id: 'yk4YXK',
    defaultMessage: 'Duties/Taxes',
    description: 'label for the duties and taxes dropdown menu',
  },
});

export default messages;
